import { Yup, type YupTypes } from "@pharmupp/p3-front-commons"

export enum MyPharmacyEnum {
  NAME = "name",
}

export const myPharmacySchema = Yup.object({
  [MyPharmacyEnum.NAME]: Yup.string().required().max(75),
})

export type MyPharmacyFormValues = YupTypes.InferType<typeof myPharmacySchema>
